const CARD = 'cards/CARD'
const CARD_ERROR = 'cards/CARD_ERROR'
const CARD_SUCCESS = 'cards/CARD_SUCCESS'

const initialState = {}

const cards = (state = initialState, action) => {
  switch (action.type) {
    case CARD: {
      return { ...state, [action.url]: { loading: true } }
    }
    case CARD_ERROR: {
      return state
    }
    case CARD_SUCCESS: {
      return { ...state, [action.data.url]: action.data }
    }
    default: {
      return state
    }
  }
}

export const addCard = (url) => async (dispatch, getState) => {
  dispatch({ type: CARD, url })
  try {
    const res = await fetch(`https://json.edhrec.com/cards/${url}`)
    const data = await res.json()
    if (res.status !== 200) {
      return dispatch({ error: data.message, type: CARD_ERROR })
    }
    return dispatch({ data, type: CARD_SUCCESS })
  } catch (e) {
    return dispatch({ error: e.message, type: CARD_ERROR })
  }
}

export default cards
